import { FormatConfig } from '@y42/model';
import { ConditionalFormattingRule } from '../conditional-formatting.model';
import { fieldId } from '../field-id.model';
import { BaseEchartsSettingsModel, MarkTypeEnum } from './base-echart-settings.model';
import { Y42SeriesModel } from './common';
import { ColorByArea } from './sub-models/color.model';
import { AxisTypeEnum, DatosAxisModel, DatosAxisPointer, TextAlignEnum } from './sub-models/datos-axis.model';
import { LabelModel } from './sub-models/label.model';
import { SizeModel } from './sub-models/size.model';
import { TooltipModel } from './sub-models/tooltip.model';

export class ScatterSettingsModel extends BaseEchartsSettingsModel<ScatterSeriesModel> {
  constructor(
    public serieAxis: DatosAxisModel = new DatosAxisModel(null, AxisTypeEnum.value, TextAlignEnum.right),
    public size: [] | [SizeModel] = [],
    series: ScatterSeriesModel[] = [],
    show_legend?: boolean,
    axisPointer?: DatosAxisPointer,
    dimensions?: fieldId[],
    breakdowns?: fieldId[],
    public conditionalFormattingRules?: ConditionalFormattingRule[],
    public colorBy?: {
      area: ColorByArea;
      hiddenValues: Record<string, boolean>;
    },
    public breakdownData = new ScatterSeriesModel(),
    public xAxis: DatosAxisModel = new DatosAxisModel(null, AxisTypeEnum.value, TextAlignEnum.right),
    public yAxis: DatosAxisModel = new DatosAxisModel(null, AxisTypeEnum.value, TextAlignEnum.right),
    public xAxis3D: DatosAxisModel = new DatosAxisModel(null, AxisTypeEnum.value, TextAlignEnum.right),
    public yAxis3D: DatosAxisModel = new DatosAxisModel(null, AxisTypeEnum.value, TextAlignEnum.right),
    public zAxis3D: DatosAxisModel = new DatosAxisModel(null, AxisTypeEnum.value, TextAlignEnum.right),
  ) {
    super(series, show_legend, axisPointer, dimensions, breakdowns);
  }
}

export class ScatterSeriesModel implements Y42SeriesModel {
  constructor(
    public field_id: fieldId | null = null,
    public label: LabelModel = new LabelModel(),
    public tooltip: TooltipModel = new TooltipModel(),
    public format = 'inherit',
    public formatConfig?: FormatConfig,
    public mark: MarkTypeEnum = MarkTypeEnum.Bar,
    public stack_name = 1, // need as unique id
    public show_right_axis = false,
    public hideFalsyValues = true,
  ) {}
}
